import { create } from 'zustand';

const dataStore = create((set) => ({
  editor:{
    controls:{
      dragging:false,
    }
  },
  mirror:{
    audio:{
      device:{
        id:null,
      },
      peer:{
        connected:false,
      },
      signalling:{
        connected:false,
        negotiating:false,
      },
    },
    camera:null,
    connected:false,
    currentDate:null,
    initiator:false,
    sessionId:null,
    socket:{
      send:null,
    },
    vitruvianId:null,
  },
  mediaprocessing:{
    peer:{
      body:null,
      face:{
        cast:{
          landmarks:{
            init:null,
            initialized:false,
            live:null
          },
        },
        facemesh:null,
      }
    },
    vitruvian:{
      body:null,
      face:{
        cast:{
          landmarks:{
            init:null,
            initialized:false,
            live:null
          },
        },
        facemesh:null,
      }
    }
  },

  data: (_data) => set((state) => ({ ...state, ..._data })),
}));

export default dataStore;
